import React, { useState } from "react";
import RecordPage from "../../components/RecordPage";
import EntityFiles, {
  attachmentsField,
  mainFromAttachments,
  afterSaveFor,
} from "../../components/EntityFiles";
import api from "../../core/api";
import { useApp } from "../../core/AppContext";
import { formatDate, todayIso } from "../../core/format";
import { letterPrint as basePrint } from "../../core/printConfigs";

// چاپ: فایل اصلی + همه‌ی فایل‌های چندگانه‌ی نامه
const letterPrint = (r, meta) => ({
  ...basePrint(r, meta),
  files: undefined,
  load: async () => {
    const files = [];
    if (r.hasFile)
      files.push({
        path: `/letters/${r.id}/file`,
        name: "فایل اصلی نامه",
        optional: false,
      });
    try {
      const { data } = await api.get(`/equipment-files/letter/${r.id}/files`);
      data.items.forEach((x) =>
        files.push({
          path: `/equipment-files/letter/${r.id}/files/${x.id}`,
          name: x.name,
          optional: false,
        }),
      );
    } catch {}
    return { files };
  },
});

export default function Letters() {
  const { meta } = useApp();
  const [filesFor, setFilesFor] = useState(null);
  const [tick, setTick] = useState(0);
  const dirs = Object.entries(meta?.letterDirections || {}).map(
    ([value, label]) => ({ value, label }),
  );

  return (
    <>
      <RecordPage
        key={tick}
        printReport={letterPrint}
        title="نامه‌نگاری"
        subtitle="ثبت و بایگانی نامه‌های وارده، صادره و داخلی"
        endpoint="/letters"
        multipart
        createLabel="ثبت نامه"
        canCreate
        canEdit
        canDelete
        initial={{ direction: "outgoing", letterDate: todayIso() }}
        filters={[{ name: "direction", label: "نوع نامه", options: dirs }]}
        hideFileButton
        transformBody={mainFromAttachments}
        afterSave={afterSaveFor("letter")}
        rowExtra={(r) => (
          <button
            className="icon-btn"
            title="فایل‌ها و تصاویر"
            onClick={() => setFilesFor(r)}
          >
            <i className="fa-solid fa-folder-open" />
          </button>
        )}
        columns={[
          {
            key: "letterNo",
            label: "شماره",
            render: (r) => <b dir="ltr">{r.letterNo}</b>,
          },
          {
            key: "letterDate",
            label: "تاریخ",
            render: (r) => formatDate(r.letterDate),
          },
          {
            key: "direction",
            label: "نوع",
            render: (r) => (
              <span className="badge wait">
                {meta?.letterDirections?.[r.direction]}
              </span>
            ),
          },
          {
            key: "subject",
            label: "موضوع",
            render: (r) => (
              <div className="clip" title={r.subject}>
                {r.subject}
              </div>
            ),
          },
          { key: "sender", label: "فرستنده" },
          { key: "recipient", label: "گیرنده" },
        ]}
        fields={[
          {
            name: "direction",
            label: "نوع نامه",
            type: "select",
            options: dirs,
            required: true,
          },
          {
            name: "letterNo",
            label: "شماره نامه",
            hint: "خالی بگذارید تا خودکار ساخته شود",
            ltr: true,
          },
          {
            name: "letterDate",
            label: "تاریخ نامه",
            type: "date",
            required: true,
            full: true,
          },
          { name: "subject", label: "موضوع", required: true, full: true },
          { name: "sender", label: "فرستنده", required: true },
          { name: "recipient", label: "گیرنده", required: true },
          { name: "body", label: "متن نامه", type: "textarea" },
          attachmentsField(
            "تصاویر / فایل‌های نامه (اختیاری، چند فایل مجاز است)",
          ),
        ]}
      />

      {filesFor && (
        <EntityFiles
          type="letter"
          id={filesFor.id}
          title={filesFor.subject}
          mainPath={filesFor.hasFile ? `/letters/${filesFor.id}/file` : null}
          canAdd
          canRemove
          onClose={() => setFilesFor(null)}
          onChanged={() => setTick((t) => t + 1)}
        />
      )}
    </>
  );
}
